import { render, staticRenderFns } from "./newPostPreview.vue?vue&type=template&id=30975044"
import script from "./newPostPreview.vue?vue&type=script&lang=js"
export * from "./newPostPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports